import profilePageEvents from '../constants/cleverTap/ResellerProfilePageEvents';
import cleverTap from '../services/cleverTap';
import * as C from '../constants/authTypes';
import * as MercehantEvents from '../constants/merchantTypes';

const FormSelectChange = '@@redux-form/CHANGE';
const FormBlurChange = '@@redux-form/BLUR';

const cleverTapWare = store => next => (action) => {
  const result = next(action);
  switch (action.type) {
    case profilePageEvents.AccordionExpanded:
      action.payload === 1 ?
        cleverTap.event(profilePageEvents.GeneralAccordionExpanded) :
        cleverTap.event(profilePageEvents.BusinessBankDetailsAccordionExpanded);
      break;
    case profilePageEvents.UpdatePasswordLoaded:
      cleverTap.event(profilePageEvents.UpdatePasswordLoaded);
      break;
    case profilePageEvents.ReferralLinkCopied:
      // cleverTap.event(profilePageEvents.ReferralLinkCopied);
      break;
    case C.UPDATE_PASSWORD_INITIATED:
      cleverTap.event(profilePageEvents.UpdatePasswordSubmitClicked);
      break;
    case C.UPDATE_PASSWORD_FAILURE:
      const errorCode = action.meta ? action.meta.errorCode : action.payload.errorCode;
      cleverTap.event(profilePageEvents.UpdatePasswordSubmitCtaError, { errorCode });
      break;
    case profilePageEvents.ResellerRegistrationTypeSelected:
      break;
    case FormSelectChange:
      if (!action.meta && action.meta.form !== 'BusinessDetailForm') break;
      let { field } = action.meta;
      if (field != 'business_entity_id') break;
      const businessEntity = store.getState().masterData.businessEntities;
      const selectedType = businessEntity.find(be => be.id == parseInt(action.payload, 10)).name;
      cleverTap.event(profilePageEvents.ResellerRegistrationTypeSelected, { type: selectedType });
      break;
    case FormBlurChange:
      if (!action.meta && action.meta.form !== 'BusinessDetailForm') break;
      if (action.meta.field !== 'gstin') break;
      cleverTap.event(profilePageEvents.ResellerGstinFilled, { GSTIN: action.payload });
      break;
    case MercehantEvents.UPDATE_RESELLER_DETAILS_INITIATED:
      cleverTap.event(profilePageEvents.ResellerProfileSubmitClicked);
      break;
    case MercehantEvents.UPDATE_RESELLER_DETAILS_FAILURE:
      cleverTap.event(profilePageEvents.ResellerProfileSubmitCtaError, { errorCode: 'Error occured while updating profile'});
      break;
    default:
      return result;
  }
  return result;
};

export default cleverTapWare;
